import React from 'react';
import { COLORS } from '../../utils/constants';

const WelcomeBack = () => {
  return (
    <div style={{
      width: '100%',
      height: '100%',
      background: `linear-gradient(135deg, ${COLORS.blue} 0%, #0052CC 100%)`,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden',
      position: 'relative'
    }}>
      <style>{`
        @keyframes fadeInUp {
          0% { transform: translateY(30px); opacity: 0; }
          100% { transform: translateY(0); opacity: 1; }
        }
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-8px); }
        }
        @keyframes pulse {
          0%, 100% { transform: scale(1); opacity: 0.6; }
          50% { transform: scale(1.05); opacity: 0.8; }
        }
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        @keyframes checkmark {
          0% { stroke-dashoffset: 50; }
          100% { stroke-dashoffset: 0; }
        }
        .fade-1 { animation: fadeInUp 0.8s ease-out 0.2s both; }
        .fade-2 { animation: fadeInUp 0.8s ease-out 0.4s both; }
        .fade-3 { animation: fadeInUp 0.8s ease-out 0.6s both; }
        .fade-4 { animation: fadeInUp 0.8s ease-out 0.8s both; }
        .float { animation: float 4s ease-in-out infinite; }
        .float-delayed { animation: float 4s ease-in-out 1s infinite; }
        .pulse { animation: pulse 3s ease-in-out infinite; }
        .spin-slow { animation: spin 20s linear infinite; }
        .checkmark-draw {
          stroke-dasharray: 50;
          stroke-dashoffset: 50;
          animation: checkmark 0.8s ease-out 1s forwards;
        }
      `}</style>

      {/* Background decorative elements */}
      <div style={{
        position: 'absolute',
        width: '500px',
        height: '500px',
        borderRadius: '50%',
        background: 'rgba(255, 255, 255, 0.03)',
        top: '-150px',
        right: '-150px'
      }} />
      <div style={{
        position: 'absolute',
        width: '350px',
        height: '350px',
        borderRadius: '50%',
        background: 'rgba(0, 255, 198, 0.06)',
        bottom: '-100px',
        left: '-100px'
      }} />

      {/* Main SVG illustration */}
      <svg width="550" height="500" viewBox="0 0 550 500" style={{ maxWidth: '95%', height: 'auto' }}>
        <defs>
          <linearGradient id="formGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" style={{ stopColor: 'white', stopOpacity: 1 }} />
            <stop offset="100%" style={{ stopColor: '#f0f9ff', stopOpacity: 1 }} />
          </linearGradient>
          <linearGradient id="accentGrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" style={{ stopColor: COLORS.mint, stopOpacity: 1 }} />
            <stop offset="100%" style={{ stopColor: '#0066FF', stopOpacity: 0.8 }} />
          </linearGradient>
        </defs>

        {/* Decorative orbit rings */}
        <g className="spin-slow" style={{ transformOrigin: '275px 220px' }}>
          <ellipse cx="275" cy="220" rx="200" ry="80" fill="none" stroke="white" strokeWidth="1" opacity="0.1" />
        </g>

        {/* Central form card */}
        <g className="fade-1 float">
          <rect x="125" y="100" width="300" height="240" rx="20" fill="url(#formGradient)" />

          {/* Form header with avatar */}
          <circle cx="275" cy="80" r="40" fill="white" />
          <circle cx="275" cy="80" r="35" fill="url(#accentGrad)" />

          {/* User icon */}
          <circle cx="275" cy="72" r="12" fill="white" />
          <path d="M 255 95 Q 275 110 295 95" fill="white" />

          {/* Form fields */}
          <rect x="155" y="135" width="240" height="40" rx="8" fill={COLORS.blue} opacity="0.08" />
          <rect x="170" y="150" width="120" height="10" rx="5" fill={COLORS.blue} opacity="0.2" />

          <rect x="155" y="190" width="240" height="40" rx="8" fill={COLORS.blue} opacity="0.08" />
          <rect x="170" y="205" width="80" height="10" rx="5" fill={COLORS.blue} opacity="0.2" />

          {/* Sign in button */}
          <rect x="155" y="255" width="240" height="50" rx="25" fill="url(#accentGrad)" />
          <text x="275" y="286" textAnchor="middle" fill="white" fontSize="14" fontWeight="600">Sign In</text>
        </g>

        {/* Floating notification cards */}
        <g className="fade-2 float-delayed">
          {/* Left notification - Forms count */}
          <rect x="30" y="180" width="110" height="70" rx="12" fill="white" opacity="0.95" />
          <circle cx="55" cy="205" r="12" fill={COLORS.mint} opacity="0.2" />
          <rect x="48" y="200" width="14" height="10" rx="2" fill={COLORS.mint} />
          <text x="75" y="228" fill={COLORS.gray} fontSize="9" fontWeight="500">Your Forms</text>
          <text x="75" y="242" fill={COLORS.blue} fontSize="16" fontWeight="700">12</text>
        </g>

        <g className="fade-3 float">
          {/* Right notification - Responses */}
          <rect x="410" y="160" width="110" height="70" rx="12" fill="white" opacity="0.95" />
          <circle cx="435" cy="185" r="12" fill={COLORS.blue} opacity="0.15" />
          <path d="M 428 185 L 435 180 L 442 185 M 435 180 L 435 192" stroke={COLORS.blue} strokeWidth="2" fill="none" strokeLinecap="round" />
          <text x="455" y="208" fill={COLORS.gray} fontSize="9" fontWeight="500">Responses</text>
          <text x="455" y="222" fill={COLORS.blue} fontSize="16" fontWeight="700">847</text>
        </g>

        {/* Activity indicators */}
        <g className="fade-3">
          {/* Recent activity card */}
          <rect x="380" y="280" width="140" height="90" rx="12" fill="white" opacity="0.95" />
          <text x="400" y="305" fill={COLORS.gray} fontSize="10" fontWeight="600">Recent Activity</text>

          {/* Activity items */}
          <circle cx="400" cy="325" r="4" fill={COLORS.mint} />
          <rect x="412" y="322" width="80" height="6" rx="3" fill={COLORS.blue} opacity="0.15" />

          <circle cx="400" cy="345" r="4" fill={COLORS.blue} opacity="0.5" />
          <rect x="412" y="342" width="60" height="6" rx="3" fill={COLORS.blue} opacity="0.1" />

          <circle cx="400" cy="365" r="4" fill={COLORS.blue} opacity="0.3" />
          <rect x="412" y="362" width="70" height="6" rx="3" fill={COLORS.blue} opacity="0.1" />
        </g>

        {/* Success checkmark */}
        <g className="fade-4">
          <circle cx="100" cy="320" r="28" fill={COLORS.mint} />
          <path
            d="M 86 320 L 96 330 L 116 308"
            stroke="white"
            strokeWidth="4"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="checkmark-draw"
          />
        </g>

        {/* Decorative elements */}
        <g className="pulse">
          <circle cx="480" cy="120" r="20" fill="white" opacity="0.1" />
          <circle cx="480" cy="120" r="12" fill={COLORS.mint} opacity="0.3" />
        </g>

        <g className="pulse" style={{ animationDelay: '1.5s' }}>
          <circle cx="70" cy="140" r="15" fill="white" opacity="0.08" />
        </g>

        {/* Small floating dots */}
        <circle cx="200" cy="380" r="4" fill="white" opacity="0.3" className="float" />
        <circle cx="350" cy="400" r="3" fill={COLORS.mint} opacity="0.4" className="float-delayed" />
        <circle cx="450" cy="380" r="5" fill="white" opacity="0.2" className="float" />

        {/* Bottom text */}
        <text x="275" y="445" textAnchor="middle" fill="white" fontSize="24" fontWeight="700" opacity="0.95">
          Welcome Back
        </text>
        <text x="275" y="475" textAnchor="middle" fill="white" fontSize="14" fontWeight="400" opacity="0.7">
          Your forms are waiting for you
        </text>
      </svg>
    </div>
  );
};

export default WelcomeBack;
